<template>
  <booking-search-details-list
    :booking="booking"/>
</template>

<script>
import { mapState } from 'vuex'
import BookingSearchDetailsList from './BookingSearchDetailsList'

export default {
  computed: mapState('booking', ['booking']),

  components: {
    BookingSearchDetailsList
  }
}
</script>
